import { BotonExportarExcel, Card, Group, Table, Tbody, Th, Thead, Tr } from "@/components/ui";
import type { EditarItemCatalogoInput } from "../services/catalogos-contables-admin-service";
import { ItemCatalogoRow, type ItemCatalogoMinimal } from "./ItemCatalogoRow";

/**
 * Tabla envuelta en card · uniforme para CeCo y Cuenta. El padre conecta
 * la mutation real de editar.
 */
export function ItemCatalogoTable({
  items,
  onGuardar,
  isPending,
  nombreExport = "catalogo-contable",
  obtenerFilasExport,
}: {
  items: ItemCatalogoMinimal[];
  onGuardar: (args: { id: string; input: EditarItemCatalogoInput }) => void;
  isPending: boolean;
  /** Nombre base del archivo Excel · lo fija el padre (cecos / cuentas). */
  nombreExport?: string;
  /** Con paginado server-side: callback que trae TODAS las páginas para el export. */
  obtenerFilasExport?: () => Promise<ItemCatalogoMinimal[]>;
}) {
  return (
    <Card padding="lg">
      <Group justify="flex-end" className="mb-2">
        <BotonExportarExcel
          archivo={nombreExport}
          hoja="Catálogo"
          filas={obtenerFilasExport ? undefined : items}
          obtenerFilas={obtenerFilasExport}
          columnas={[
            { header: "Código", value: (i) => i.codigo },
            { header: "Nombre", value: (i) => i.nombre },
          ]}
        />
      </Group>
      <div className="overflow-x-auto">
        <Table verticalSpacing="sm">
          <Thead>
            <Tr>
              <Th>Código</Th>
              <Th>Nombre</Th>
              <Th />
            </Tr>
          </Thead>
          <Tbody>
            {items.map((item) => (
              <ItemCatalogoRow key={item.id} item={item} onGuardar={onGuardar} isPending={isPending} />
            ))}
          </Tbody>
        </Table>
      </div>
    </Card>
  );
}
